
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Lead } from '@/types';

@Component
export default class LeadRelinkDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  valid = false
  loading = false

  code: string | null = null;

  @Watch('value')
  onValueChange(val: boolean) {
    if (val === true) {
      this.code = null;
    }

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (val === true) {
      this.$nextTick(() => {
        if (this.form) this.form.reset();
      });
    }

    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get form(): Vue & { validate: () => boolean; reset: () => boolean } {
    return this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };
  }

  onCancel() {
    this.dialog = false;
  }

  async onRelink() {
    if (this.form.validate()) {
      this.loading = true;

      try {
        await this.$store.dispatch('relinkLead', {
          fatherId: Number(this.code?.replace(/\D/g, '')),
        });

        this.dialog = false;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } catch (error) {
        this.loading = false;
      }
    }
  }
}
